import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';         // Import Home page
import Login from './pages/Login';
import Register from './pages/Register';
import DashboardHome from './pages/dashboard/DashboardHome';
import ProtectedRoute from './components/ProtectedRoute';
import Profile from './pages/dashboard/Profile';
import DashboardLayout from './components/DashboardLayout';
import Courses from './pages/dashboard/Courses';
import CoursesCreate from './pages/dashboard/Courses/CoursesCreate';
import CoursesDetail from './pages/dashboard/Courses/CoursesDetail';
import CourseLayout from './layouts/CourseLayout'; // Import the CourseLayout
import CourseView from './pages/public/CourseView';   // Import the CourseView
import CourseApplicantsPage from './pages/dashboard/Courses/CoursesApplicantsPage';
import StudentCourses from './pages/dashboard/student/StudentCourses';
import CoursesPublic from './pages/public/CoursesPublic';
import StudentsList from './pages/StudentsList';
import QuizScoresList from './pages/dashboard/QuizScoresList';
import StudentQuizzes from './pages/dashboard/student/StudentQuizzes';
import CalendarView from './pages/dashboard/Calendar';
import MediaLibrary from './pages/dashboard/MediaLibrary';
import Widget from './components/Widget';
import ChatbotAIQuizzesAdd from './pages/dashboard/ChatbotAIQuizzesAdd';
import ChatbotAIQuizEditor from './pages/dashboard/ChatbotAIQuizEditor';
import ChatbotAIQuizzesList from './pages/dashboard/ChatbotAIQuizzesList';
import StudentTranscriptList from './pages/StudentTranscriptList';
import TranscriptPage from './pages/TranscriptPage';
import MessagingSystem from './pages/dashboard/MessagingSystem';

function App() {

  const userRole = localStorage.getItem('role');

  console.log('userRole',userRole)


  return (
    <>
    <Routes>
      {/* Home Page */}
      <Route path="/" element={<Home />} />

      {/* Login Page */}
      <Route path="/login" element={<Login />} />

      {/* Register Page */}
      <Route path="/register" element={<Register />} />

      <Route path="/courses" element={<CoursesPublic />} />
      
      {/* Public Course View */}
      <Route path="/course" element={<CourseLayout />}>
        <Route path=":id" element={<CourseView />} />
      </Route>

      {/* Protected Dashboard */}
      <Route path="/dashboard" element={<ProtectedRoute />}>
        <Route element={<DashboardLayout />}>
          <Route index element={<DashboardHome />} />
          <Route path="profile" element={<Profile />} />
          <Route path="profile/courses" element={<StudentCourses />} />
          <Route path="profile/quizzes" element={<StudentQuizzes />} />
          <Route path="calendar" element={<CalendarView />} />
          <Route path="messages" element={<MessagingSystem />} />
          {userRole && userRole === 'admin' && (
            <>
              <Route path="courses" element={<Courses />} />
              <Route path="courses/create" element={<CoursesCreate />} />
              <Route path="courses/:id" element={<CoursesDetail />} />
              <Route path="courses/applicants/:id" element={<CourseApplicantsPage />} />
              <Route path="students" element={<StudentsList />} />
              <Route path="quizzes" element={<QuizScoresList />} />
              <Route path="transcripts" element={<StudentTranscriptList />} />
              <Route path="transcripts/:studentEmail" element={<TranscriptPage />} />
              <Route path="media-library" element={<MediaLibrary />} />
              <Route path="chatbotai-quizzes" element={<ChatbotAIQuizzesList />} />
              <Route path="chatbotai-quizzes/add" element={<ChatbotAIQuizzesAdd />} />
              <Route path="chatbotai-quizzes/quiz/:id" element={<ChatbotAIQuizEditor />} />
            </>
          )}
        </Route>
      </Route>

      {/* Default Route (redirect to home) */}
      <Route path="*" element={<Home />} />
    </Routes>
    <Widget />
    </>
  );
}

export default App;